import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  public $ready = new BehaviorSubject<boolean>(false);
  private localeIdMap = new Map<string, string>([['de', 'de-CH'], ['fr', 'fr-CH'], ['it', 'it-CH'], ['en', 'en-GB'], ['nl', 'nl'], ['es', 'es'], ['tr', 'tr']]);
  private currentLanguage = 'de';
  private currentLocale: string;
  private translatedData: any;

  constructor(private connection: ConnectionService) {
    this.currentLocale = 'de-CH';
  }

  public loadTranslation(lang: string): Promise<boolean> {
    this.$ready.next(false);
    this.currentLocale = this.localeIdMap.get(lang) as any;
    this.currentLanguage = lang;
    import('/node_modules/@angular/common/locales/' + this.currentLocale + '.mjs').then(language => registerLocaleData(language.default));

    return this.connection.getSimple('assets/i18n/' + lang + '.json').then(result => {
      this.translatedData = result;
      this.$ready.next(true);
      return Promise.resolve(true);
    });
  }

  public get(key: string): string {
    if (_.get(this.translatedData, key)) {
      return _.get(this.translatedData, key);
    }
    return key;
  }

  public getCurrentLocale(): string {
    return this.currentLocale;
  }

  public getCurrentLanguage(): string {
    return this.currentLanguage;
  }
}
